import vxlColors from 'shared/styles/color/core';

const text = {
  primary: vxlColors.core.neutrals.black,
  secondary: vxlColors.core.neutrals.grey[600],
  tertiary: vxlColors.core.neutrals.grey[400],
  muted: vxlColors.core.neutrals.grey[400],
  inverse: vxlColors.core.neutrals.white,
};

export default text;
